import type { IconName } from '@lego/icons'
import iconsPackageJson from '@lego/icons/package.json'
const ICONS_CDN_URL = `https://assets.lego.com/icons/v${iconsPackageJson.version}`

export const getIconSrc = (name: IconName, solid = false) => {
  const postfix = solid ? '-solid' : ''

  return `${ICONS_CDN_URL}/${name}${postfix}.svg`
}
